import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {provideAnimations} from '@angular/platform-browser/animations';
import {InputTextModule} from 'primeng/inputtext';
import {BadgeModule} from 'primeng/badge';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RippleModule} from 'primeng/ripple';
import {AppSidebarMenuComponent} from './app.sidebar-menu.component';
import {RouterModule} from '@angular/router';
import {AppFooterComponent} from './app.footer.component';
import {AppSidebarComponent} from './app.sidebar.component';
import {AppLayoutPage} from './app.layout.page';
import {MenuModule} from 'primeng/menu';
import {AvatarModule} from 'primeng/avatar';
import {CapitalizeFirstPipe} from '../shared/pipes/capitalize-first.pipe';
import {CommonModule, NgOptimizedImage, TitleCasePipe} from '@angular/common';
import {Button, ButtonDirective} from 'primeng/button';
import {SkeletonModule} from 'primeng/skeleton';
import {ToastModule} from 'primeng/toast';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {BackButtonComponent} from '../shared/components/back-button/back-button.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {AuthDirective} from '../shared/directives/auth.directive';
import {MessageService} from 'primeng/api';
import {LogoComponent} from '../shared/components/logo/logo.component';
import {LogoDdhComponent} from '../shared/components/logo-ddh/logo-ddh.component';
import {DarkModeSelectorComponent} from '../shared/components/dark-mode-selector/dark-mode-selector.component';
import {Tooltip} from 'primeng/tooltip';
import {Popover} from 'primeng/popover';
import {AppTopBarComponent} from './app.top-bar.component';
import {DayAgendaComponent} from '../shared/components/day-agenda/day-agenda.component';
import {StyleClassModule} from 'primeng/styleclass';
import {AppMenuItemComponent} from './app.menu-item.component';
import {SelectButton} from 'primeng/selectbutton';
import {MetricCardComponent} from '../shared/components/card/metric-card/metric-card.component';
import {
  MediaViewerDialogComponent
} from "../shared/components/media-viewer/media-viewer-dialog.component";
import {DesktopWrapperComponent} from "../shared/components/desktop-wrapper/desktop-wrapper.component";
import {RoleGateComponent} from "../shared/components/role-gate/role-gate.component";

@NgModule({
  declarations: [
    AppMenuItemComponent,
    AppFooterComponent,
    AppSidebarMenuComponent,
    AppTopBarComponent,
    AppSidebarComponent,
    AppLayoutPage,
  ],
  imports: [
    AuthDirective,
    AvatarModule,
    BackButtonComponent,
    BadgeModule,
    BreadcrumbModule,
    BrowserModule,
    Button,
    ButtonDirective,
    CapitalizeFirstPipe,
    CommonModule,
    DarkModeSelectorComponent,
    FormsModule,
    InputTextModule,
    LogoComponent,
    LogoDdhComponent,
    MenuModule,
    NgOptimizedImage,
    ProgressSpinnerModule,
    RadioButtonModule,
    RippleModule,
    RouterModule,
    SkeletonModule,
    StyleClassModule,
    ToastModule,
    Tooltip,
    Popover,
    DayAgendaComponent,
    SelectButton,
    MetricCardComponent,
    MediaViewerDialogComponent,
    DesktopWrapperComponent,
    RoleGateComponent,
  ],
  providers: [
    provideAnimations(),
    TitleCasePipe,
    CapitalizeFirstPipe,
    MessageService,
  ],
  exports: [AppLayoutPage]
})
export class AppLayoutModule {
}
